import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api_comm from "../../common/lib";

export const getIncentivePayouts = createAsyncThunk(
	"Incentive/Payouts",
	async (args, { getState }) => {
		const state = getState();

		try {
			let IncentivePayouts = await api_comm(
				"get",
				`/finances/api/v2/incentives/payouts/${state.Login.Auth.storemember_guid}`,
				{},
				state.Login.Auth.session_token
			);

			return IncentivePayouts?.data?.data;
		} catch (e) {
			if (e.data.error) {
				console.log(e.data.data.error);
			}
			console.log("Error:::", e);
			return e?.message;
		}
	}
);

const initialState = {
	Payouts: [],
	loading: true,
};

export const IncentivePayoutSlice = createSlice({
	name: "IncentivePayouts",
	initialState,
	reducers: {
		setBalance: (state, action) => {
			state.Payouts = action.payload;
		},
	},
	extraReducers: {
		[getIncentivePayouts.pending]: (state, action) => {
			state.loading = true;
		},
		[getIncentivePayouts.fulfilled]: (state, action) => {
			// console.log("action.payload getIncentivePayouts ==> ", action.payload);
			let sortedPayouts = action.payload;

			sortedPayouts.sort((a, b) =>
				a?.incentive_value < b?.incentive_value ? 1 : -1
			);

			state.Payouts = sortedPayouts;
			state.loading = false;
		},
		[getIncentivePayouts.rejected]: (state, action) => {
			state.Payouts = [];
			state.error = action.payload;
			state.loading = false;
		},
	},
});

export const { setBalance } = IncentivePayoutSlice.actions;

export default IncentivePayoutSlice.reducer;
